import { Component } from 'react';
import './index.scss';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="errorPage">
          <div className="errorPage__wrapper">
            <svg
              className="errorPage__image"
              width="512"
              height="512"
              viewBox="0 0 512 512"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g opacity="0.5">
                <path
                  d="M400.6 289.564C339.174 289.564 289.201 339.538 289.201 400.964C294.801 548.549 506.423 548.507 512.001 400.963C512 339.537 462.026 289.564 400.6 289.564V289.564ZM433.928 434.292C428.07 440.15 418.573 440.15 412.715 434.292L400.6 422.177L388.485 434.292C382.627 440.15 373.13 440.15 367.272 434.292C361.414 428.434 361.414 418.937 367.272 413.079L379.387 400.964L367.272 388.849C361.414 382.991 361.414 373.494 367.272 367.636C373.13 361.778 382.627 361.778 388.485 367.636L400.6 379.75L412.715 367.635C418.573 361.777 428.07 361.777 433.928 367.635C439.786 373.493 439.786 382.99 433.928 388.848L421.813 400.963L433.928 413.078C439.786 418.937 439.786 428.434 433.928 434.292V434.292Z"
                  fill="#F94E4E"
                />
                <path
                  d="M290.784 250.393C337.003 293.356 401.131 229.328 358.14 183.037C288.577 113.474 175.792 113.474 106.229 183.037C87.6291 201.637 87.6291 231.793 106.229 250.393C124.829 268.993 154.985 268.993 173.585 250.393C205.948 218.029 258.42 218.029 290.784 250.393Z"
                  fill="#2B4775"
                />
                <path
                  d="M383.062 158.115C429.218 201.064 493.434 137.089 450.417 90.759C329.89 -29.768 134.477 -29.768 13.95 90.759C-4.65 109.359 -4.65 139.515 13.95 158.115C32.55 176.715 62.706 176.715 81.306 158.115C164.633 74.787 299.734 74.787 383.062 158.115Z"
                  fill="#2B4775"
                />
                <path
                  d="M232.184 261.365C205.88 261.365 184.556 282.689 184.556 308.993C186.891 372.102 277.486 372.085 279.811 308.992C279.811 282.689 258.488 261.365 232.184 261.365V261.365Z"
                  fill="#2B4775"
                />
              </g>
            </svg>

            <h1 className="errorPage__heading">Something went wrong!</h1>
            <p className="errorPage__context">
              Try checking your network connection.
            </p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
